import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField/index';
import { disabledButtonTextGray, hintTextGrayColor } from 'theme/mainColors';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

class TTListItemInput extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = {
      value: props.value
    };
  }

  handleTextFieldChange = (ev, value) => this.setState({ value });

  handleTextFieldBlur = ev => this.props.onBlur(this.props.id, ev.target.value);

  handleCloseButtonClick = () => this.props.onDelete(this.props.id);

  render() {
    const { disabled } = this.props;
    return (
      <div className={ 'tt-list-item-input' }>
        <div className={ 'tt-source-input__input-container' }>
          <TextField
            hintText="Input Data Value"
            value={ this.state.value }
            style={ { marginTop: -20 } }
            hintStyle={ { fontSize: 13, color: hintTextGrayColor } }
            inputStyle={ { fontSize: 13 } }
            underlineStyle={ { borderColor: disabledButtonTextGray } }
            onChange={ this.handleTextFieldChange }
            onBlur={ this.handleTextFieldBlur }
            fullWidth={ true }
            disabled={ disabled }
          />
        </div>
        {
          !disabled &&
          <CloseIcon
            color={ hintTextGrayColor }
            hoverColor={ disabledButtonTextGray }
            style={ {
              borderBottom: `1px solid ${ disabledButtonTextGray }`,
              boxSizing: 'content-box',
              paddingBottom: 4,
              marginBottom: 8,
              height: 20,
              width: 20,
              cursor: 'pointer',
              paddingRight: 10
            } }
            onClick={ this.handleCloseButtonClick }
          />
        }
      </div>
    );
  }
}

TTListItemInput.propTypes = {
  id: PropTypes.number.isRequired,
  value: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

TTListItemInput.defaultProps = {
  value: '',
  disabled: false
};

export default TTListItemInput;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttManageMappingList/c/ttListItemInput/TTListItemInput.js